import { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Select } from 'antd';
import { drawerWidth, formItemLayout } from '../../../utils/constants';
import UsersServices from '../../../services/usersServices';
import { useSelector } from 'react-redux';
import { DrawerFormButtons } from '../../../components/common/drawersFormButtons';
import { useTranslation } from 'react-i18next';
import { useUserAuth } from '../../../context/UserContext';
import { CreateUserPayload } from './users.types';
import { getCountryLabel } from '../../../utils/functions';
import { useMutation, useQueryClient } from "@tanstack/react-query";

const NewUser = ({ open, onClose }: { open: boolean, onClose: () => void }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { applications } = useUserAuth();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    // const [loadingButton, setLoadingButton] = useState(false);
    const countries = useSelector((state: any) => state.utils.countries);
    const { roles } = useSelector((state: any) => state.roles);

    const createUserMutation = useMutation({
        mutationFn: UsersServices.createUser,    
        onSuccess: (respData) => {
            if (respData.success) {
                message.success(t('messages.success'));
    
                queryClient.invalidateQueries({
                    queryKey: ["users"]
                });
    
                onClose();
            }
            else {
                message.error(t('messages.errorAccured'));
            }
        },
    
        onError: () => {
            message.error(t('messages.errorAccured'));
        }
    });

    const saveData = (values: CreateUserPayload) => {
        createUserMutation.mutate(values);
    };

    // const saveData = async (values: CreateUserPayload) => {
    //     setLoadingButton(true);
    //     try {
    //         const respData = await UsersServices.createUser(values);
    //         if (respData.success) {
    //             message.success(t('messages.success'));
    //             getUsers();
    //             onClose();
    //         }
    //         else {
    //             message.error(t('messages.errorAccured'));
    //         }
    //     } catch (error) {
    //         message.error(t('messages.errorAccured'));
    //     }
    //     finally {
    //         setLoadingButton(false);
    //     }
    // }

    return (
        <Drawer
            title={t('users.addNewUser')}
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={createUserMutation.isPending} formId={"newUser"} />
            }
        >
            <Form
                id="newUser"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label={t('users.name')}
                            name="name"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label={t('users.lastname')}
                            name="surname"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label={t('users.username')}
                            name="username"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label={t('users.email')}
                            name="email"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label={t('users.role')}
                            name="roleID"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Select
                                showSearch
                                placeholder={t('general.select')}
                                optionFilterProp="label"
                                options={roles}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label={t('users.country')}
                            name="userCountries"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Select
                                showSearch
                                mode='multiple'
                                placeholder={t('general.select')}
                                optionFilterProp="label"
                                options={countries.map((item: any) => ({ value: item.id, label: getCountryLabel(item) }))}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label={t('users.application')}
                            name="applicationID"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Select
                                showSearch
                                placeholder={t('general.select')}
                                optionFilterProp="label"
                                options={applications}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default NewUser;